import React, { FC } from 'react';
import styles from './index.module.less';

interface SuccessToastContentProps {
  title?: string;
}

export const SuccessToastContent: FC<SuccessToastContentProps> = ({ title }) => (
  <div className={styles.toastContainer}>
    <svg
      className="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="200"
    >
      <path
        d="M512 74.666667C270.933333 74.666667 74.666667 270.933333 74.666667 512S270.933333 949.333333 512 949.333333 949.333333 753.066667 949.333333 512 753.066667 74.666667 512 74.666667z m0 810.666666c-204.8 0-373.333333-168.533333-373.333333-373.333333S307.2 138.666667 512 138.666667 885.333333 307.2 885.333333 512 716.8 885.333333 512 885.333333z"
        fill="#fff"
      />
      <path
        d="M701.866667 381.866667L448 637.866667 322.133333 512c-12.8-12.8-32-12.8-44.8 0-12.8 12.8-12.8 32 0 44.8l149.333334 149.333333c6.4 6.4 14.933333 8.533333 23.466666 8.533334s17.066667-2.133333 23.466667-8.533334l277.333333-277.333333c12.8-12.8 12.8-32 0-44.8-14.933333-12.8-36.266667-12.8-49.066666-2.133333z"
        fill="#fff"
      />
    </svg>
    <div className={styles.msg}>{title}</div>
  </div>
);

interface SimpleToastProps {
  children: React.ReactNode;
}

export const SimpleToast: FC<SimpleToastProps> = ({ children }) => <div className={styles.simpleToast}>{children}</div>;
